import { render } from "./MyFooter.vue?vue&type=template&id=fe20a07c&ts=true"
import script from "./MyFooter.vue?vue&type=script&lang=ts"
export * from "./MyFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__